import { createFileRoute } from '@tanstack/react-router';
import { ClientTable } from '@/components/Pages/Clients/ClientTable';
import { CreateEditClientModal } from '@/components/Pages/Clients/CreateEditClientModal';
import { Box } from '@mui/joy';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/clients/')({
  component: ClientsPage,
});

function ClientsPage() {
  const { isAdmin, isSuperAdmin, isSeller } = useAuth();
  const showActions = isAdmin || isSuperAdmin || isSeller;

  return (
    <Box>
      {showActions && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
          <CreateEditClientModal />
        </Box>
      )}
      <ClientTable />
    </Box>
  );
}
